<template>
  <div class="bindAccount_box">
    <div class="associated_list_box">
      <ul class="associated_list">
        <li class="associated_item clearfix"
            v-for="(item,index) in associated_list"
            :key="index">
          <div class="associated_item_left clearfix"> <span class="icon">
              <img :src="item.icon"
                   alt="">
            </span>
            <span class="name">{{item.name}}</span>
          </div>
          <div class="associated_item_right clearfix"><span class="account_name">{{item.account_name}}</span>
            <span :class="item.binded==1?'btn_active':'btn'">
              <!-- 解绑 -->
              {{item.binded==1?$t('bindAccountText.text1'):$t('bindAccountText.text2')}}
            </span>
          </div>
        </li>
        <li class="associated_item clearfix fundoll_btn">
          <div class="line"></div>
          <div class="associated_item_left clearfix"> <span class="icon">
              <img :src="imgSrc"
                   alt="">
            </span>
            <span class="name">{{name}}</span>
          </div>
          <div class="associated_item_right clearfix"><span class="account_name"></span>
            <span class="btn">
              {{$t('bindAccountText.text2')}}
              <!-- {{item.binded==1?'解绑':'绑定'}} -->
            </span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getSessionStorage } from '@/utils/stage'
export default {
  data() {
    return {
      name: '',
      imgSrc: require('../../assets/images/favicon.png'),
      associated_list: [
        {
          icon: require('../../assets/images/fb_btn.png'),
          name: 'Facebook',
          account_name: 'paopao',
          binded: 1,
        },
        {
          icon: require('../../assets/images/twitter_btn.png'),
          name: 'Twitter',
          account_name: 'paopao1',
          binded: 1,
        },
        {
          icon: require('../../assets/images/google_btn.png'),
          name: 'Google',
          account_name: '',
          binded: 0,
        },
        {
          icon: require('../../assets/images/apple_btn.png'),
          name: 'Apple',
          account_name: '',
          binded: 0,
        },
        {
          icon: require('../../assets/images/line_btn.png'),
          name: 'Line',
          account_name: '',
          binded: 0,
        },
        {
          icon: require('../../assets/images/ins_btn.png'),
          name: 'Insgrame',
          account_name: '',
          binded: 0,
        },
        {
          icon: require('../../assets/images/games_center_btn.png'),
          name: 'Game Center',
          account_name: '110',
          binded: 0,
        },
        {
          icon: require('../../assets/images/kakao.png'),
          name: 'KaKao',
          account_name: '',
          channel: '112',
          binded: 0,
        },
        {
          icon: require('../../assets/images/n_btn.png'),
          name: 'Naver',
          account_name: '',
          channel: '113',
          binded: 0,
        },
        // {
        //   icon: require('../../assets/images/gpg.png'),
        //   name: 'Google Play Games',
        //   account_name: '',
        //   binded: 0,
        // },
      ],
    }
  },
  created() {
    if (getSessionStorage('zm') == 1) {
      this.name = this.$t('bindAccountText.text6').replace(
        'FUNDOLL',
        'Cat Fantasy'
      )
      this.imgSrc = require('../../assets/images/zm.png')
    } else {
      this.name = this.$t('bindAccountText.text6')
    }
  },
}
</script>

<style lang="less" scope>
.bindAccount_box {
  padding: 30/75rem;
  box-sizing: border-box;
  .associated_list_box {
    .associated_list {
      .associated_item {
        width: 100%;
        margin-bottom: 30/75rem;
        .line {
          width: 630/75rem;
          height: 1px;
          background: #c7c7c7;
          margin: 0 auto;
          margin-bottom: 30/75rem;
        }
        span {
          display: inline-block;
          float: left;
          font-size: 28/75rem;
          height: 80/75rem;
          line-height: 80/75rem;
        }
        .icon {
          width: 80/75rem;
          height: 80/75rem;
        }
        .name {
          font-weight: bold;
          color: #575757;
          margin-left: 20/75rem;
        }
        .account_name {
          font-weight: 500;
          color: #c7c7c7;
        }
        .btn {
          width: 153/75rem;
          height: 55/75rem;
          background: #f2f3f4;
          border-radius: 28/75rem 28/75rem 28/75rem 28/75rem;
          color: #454545;
          font-size: 26/75rem;
          text-align: center;
          line-height: 55/75rem;
          margin-top: 12/75rem;
          margin-left: 10/75rem;
        }
        .btn_active {
          width: 153/75rem;
          height: 55/75rem;
          color: #ff7391;
          border: 1px solid #ff7391;
          border-radius: 28/75rem 28/75rem 28/75rem 28/75rem;
          font-size: 26/75rem;
          text-align: center;
          line-height: 55/75rem;
          margin-top: 12/75rem;
          margin-left: 10/75rem;
          background: none;
        }
        .associated_item_right {
          float: right;
        }
        .associated_item_left {
          float: left;
        }
      }
      //   .fundoll_btn {
      //     border-top: 1px solid #c7c7c7;
      //   }
    }
  }
}
</style>